import Phaser from 'phaser';

export abstract class GameBaseScene extends Phaser.Scene {
  get defaultGameHeight() {
    return this.game.config.height as number;
  }

  get defaultGameWidth() {
    return this.game.config.width as number;
  }

  constructor(config: string | Phaser.Types.Scenes.SettingsConfig) {
    super(config);
  }

  public init(_data = undefined) {
    this.initListeners();
  }

  public create() {
    this.initGraphics();
    this.onSceneReady(this.scene.key);
  }

  protected initListeners() {
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.onDestroy(), this);

    window.addEventListener('resize', (_event) => {
      this.onResizeEvent();
    });

    this.load.on(
      Phaser.Loader.Events.PROGRESS,
      (progress: number) => this.onLoadProgress(progress),
      this,
    );
    this.load.on(Phaser.Loader.Events.COMPLETE, () => this.onLoadComplete(), this);
  }

  protected initGraphics() {
    // Empty in base
  }

  protected onResizeEvent() {
    // Empty in base
  }

  protected onLoadProgress(_progress: number) {
    // Empty in base
  }

  protected onLoadComplete() {
    // Empty in base
  }

  protected onSceneReady(_key: string) {
    // Empty in base
  }

  protected onDestroy() {
    this.load.off(
      Phaser.Loader.Events.PROGRESS,
      (progress: number) => this.onLoadProgress(progress),
      this,
    );
    this.load.off(Phaser.Loader.Events.COMPLETE, () => this.onLoadComplete(), this);
  }
}
